import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export function useOrderSubmissionEffect({
    usageOrderSubmission,
    setCurrentActivity,
    REPORTPROGRESSTEPS,
    currentActivity,
    unlockOrderFunc,
    myCaseResourceType,
    myCaseRefId,
    setShowSaveExitCompletionPopup,
}) {
    useEffectWithErrorLogging(() => {
        if (
            usageOrderSubmission &&
            (usageOrderSubmission?.statusCode ||
                usageOrderSubmission?.errorCode) 
        ) {
            if (usageOrderSubmission?.clickedBtn === 'submit') {
                setCurrentActivity(
                    REPORTPROGRESSTEPS[
                        REPORTPROGRESSTEPS.findIndex(
                            (activity) => activity === currentActivity
                        ) + 1
                    ]
                );
                (myCaseRefId && myCaseRefId?.length > 0) && unlockOrderFunc({
                    action:
                        myCaseResourceType === 'reportPayment'
                            ? 'ReportPayment'
                            : myCaseResourceType === 'draft'
                            ? 'DraftUsageEdit'
                            : 'ReportUsage',
                    myCaseRefId: myCaseRefId,
                });
            } else if (usageOrderSubmission?.clickedBtn === 'save&exit') {
                setShowSaveExitCompletionPopup(true);
            }
        }
    }, [usageOrderSubmission]);
}